module.exports = __webpack_public_path__ + "img/LamdeiniLearning-70.ae1f8a7b.jpg";